module.exports = __webpack_public_path__ + "img/selected2-min.e58d45a3.png";